import { useEffect, useRef } from 'react';
import { useGetLevelDetails } from '../Controllers/DashboardController';
import { save, retrieve } from '../helpers/StorageHelper';
import { USER_CURRENT_LEVEL } from '../constants/localStorageKeys';
import useAuthStore from '../zustand-stores/AuthStore';

export const useLevelUpDetection = () => {
    const { authSessionExists } = useAuthStore();
    const { data: levelDetailsData } = useGetLevelDetails(authSessionExists); // Only fetch if authenticated
    const currentLevel = levelDetailsData?.level_details?.current_level;
    const previousLevelRef = useRef(null);

    useEffect(() => {
        // Only run level detection if user is authenticated
        if (!authSessionExists) {

            return;
        }

        if (currentLevel !== undefined && currentLevel !== null) {
            const storedLevel = retrieve(USER_CURRENT_LEVEL);


            // Initialize stored level if it doesn't exist
            if (storedLevel === null) {

                save(USER_CURRENT_LEVEL, currentLevel);
                previousLevelRef.current = currentLevel;
                return;
            }

            // Check if level increased
            if (currentLevel > storedLevel) {
                // Level up detected!

                dispatchLevelUpEvent(currentLevel, storedLevel);
            }

            // Update stored level
            save(USER_CURRENT_LEVEL, currentLevel);
            previousLevelRef.current = currentLevel;
        }
    }, [currentLevel, authSessionExists]); // Add authSessionExists to dependencies

    return { currentLevel };
};

const dispatchLevelUpEvent = (newLevel, oldLevel) => {

    const event = new CustomEvent('levelUp', {
        detail: { newLevel, oldLevel }
    });
    window.dispatchEvent(event);
};